<ng-container>
  <div class="row">
    <!-- Prametre drop down -->
    <div class="col-lg-11">
      <ng-container *ngIf="config.label">
        <label [for]="config.id"><strong>{{ config.label }}</strong></label> </ng-container><br />

      <ng-container *ngIf="config.editMode && userService.userHasChampViewPermissionAccess(config.name,typeName)">
        <div *ngIf="!simpleMode">
          <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
            <mat-select *ngIf="!simpleMode" [disabled]="config.disabled" [(value)]="config.value"
              [(ngModel)]="config.value" [compareWith]="compareValeurs">
              <mat-option [value]="null">Veuillez sélectionner</mat-option>
              <mat-option *ngFor="let item of config.dropdownList | sortByLabel" [value]="item">
                <div *ngIf="!config.entiteClassSelection && item?.mapLocalLibelle">
                  <label *ngIf="config?.isMultiLangue">
                    {{ item?.valeur }}-{{
                    item?.mapLocalLibelle[config.labelLocal]
                    }}</label>
                  <label *ngIf="!config.isMultiLangue">{{ item?.mapLocalLibelle?.['fr_FR'] ?? item.valeur
                    }}</label>
                </div>
                <div *ngIf="config.entiteClassSelection">
                  <label *ngIf="config.displayProperty">{{ item[config.displayProperty]}}</label>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="simpleMode">
          <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
            <mat-select [disabled]="config.disabled" [(ngModel)]="config.value" [(value)]="config.value">
              <mat-option [value]="null">Veuillez sélectionner</mat-option>
              <mat-option [value]="true">Oui</mat-option>
              <mat-option [value]="false">Non</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container
        *ngIf="(!config.editMode &&!simpleMode )|| (!userService.userHasChampViewPermissionAccess(config.name,config.typeName))&& config.editMode">
        <div *ngIf="!config.entiteClassSelection">
          <div *ngIf="config.isMultiLangue && value?.mapLocalLibelle">
            <span *ngIf="value?.valeurHexa !== null"
              style="display:inline-block;width:12px;height:12px;border-radius:50%;"
              [ngStyle]="{ 'background-color': value?.valeurHexa }"></span>
            {{ value?.valeur }}-{{ value?.mapLocalLibelle[config.labelLocal] }}
          </div>
          <div *ngIf="!config.isMultiLangue">{{ value?.mapLocalLibelle?.['fr_FR'] ?? value?.valeur }}</div>
        </div>
        <div *ngIf="config.entiteClassSelection">
          <div *ngIf="config.displayProperty">{{ value[config.displayProperty] }}</div>
        </div>
      </ng-container>
      <!-- userService.userHasRight('Génération de QR Code', '') && -->
      <ng-container
        *ngIf="!config.editMode &&simpleMode || (!userService.userHasChampViewPermissionAccess(config.name,config.typeName))&& config.editMode &&simpleMode">
        <div>{{ config.value | booleanToFrench}}</div>
        <div class="mt-1" style="display: flex; align-items: center;"
          *ngIf="config.value === true && config.name === 'qRCodeGeneration'">
          <qrcode [elementType]="'svg'" style="display: inline-block;" (qrCodeURL)="onChangeURL($event)"
            [qrdata]="qrCode" [width]="256" [margin]="0" [errorCorrectionLevel]="'M'"></qrcode>
          <a class="ml-3" [href]="qrCodeDownloadLink" download="qrcode"><mat-icon fontIcon="download"></mat-icon></a>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<br />